import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 73,
	height: 73,
	viewBox: "0 0 73 73",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_43_189)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M51.82 2.88C55.02 8.23 56.86 14.49 56.86 21.18C56.86 40.89 40.88 56.87 21.17 56.87C14.48 56.87 8.22 55.03 2.87 51.83C9.1 62.25 20.49 69.22 33.51 69.22C53.22 69.22 69.2 53.24 69.2 33.53C69.2 20.51 62.23 9.12 51.81 2.89L51.82 2.88Z",
			stroke: "white",
			strokeWidth: 5.76,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M51.82 2.88C55.02 8.23 56.86 14.49 56.86 21.18C56.86 40.89 40.88 56.87 21.17 56.87C14.48 56.87 8.22 55.03 2.87 51.83C9.1 62.25 20.49 69.22 33.51 69.22C53.22 69.22 69.2 53.24 69.2 33.53C69.2 20.51 62.23 9.12 51.81 2.89L51.82 2.88Z",
			fill: "#F5C960"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_43_189",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 72.09,
			height: 72.09,
			fill: "white"
		})
	}) })]
});
export default SvgMoon;
